import { css as glamorCss } from 'glamor';
var hide = glamorCss.keyframes('message-hide', {
  from: {
    right: 0
  },
  to: {
    right: '100%'
  }
});
var reveal = glamorCss.keyframes('message-reveal', {
  from: {
    right: '100%'
  },
  to: {
    right: 0
  }
});

var defaultStyles = function defaultStyles(_ref) {
  var colors = _ref.colors,
      fonts = _ref.fonts;
  return {
    button: {
      border: 'none',
      color: colors.mediumLightGrey,
      cursor: 'pointer',
      marginRight: 8,
      outline: 'none',
      padding: 0,
      transition: 'background-color 200ms 0ms linear, color 200ms 0ms linear',
      ':hover': {
        color: colors.adminBlue
      }
    },
    buttonDisabled: {
      color: colors.defaultGrey,
      cursor: 'not-allowed',
      ':hover': {
        color: colors.defaultGrey
      }
    },
    buttonWrapper: {
      position: 'relative',
      lineHeight: '18px'
    },
    clipContent: {
      fontFamily: fonts["default"],
      fontSize: 12,
      lineHeight: '14px'
    },
    icon: {
      color: colors.darkGrey,
      marginLeft: 8,
      transition: 'background-color 200ms 0ms linear, color 200ms 0ms linear',
      '.clipboard:hover &': {
        color: colors.adminBlue
      }
    },
    iconDisabled: {
      color: colors.defaultGrey,
      '.clipboard:hover &': {
        color: colors.defaultGrey
      }
    },
    label: {
      color: colors.darkGrey,
      fontSize: 12,
      fontWeight: 'bold',
      lineHeight: '16px',
      marginRight: 8
    },
    labelDisabled: {
      color: colors.mediumLightGrey
    },
    root: {
      alignItems: 'baseline',
      display: 'flex',
      flexFlow: 'column wrap',
      position: 'relative'
    },
    tooltip: {
      animation: "".concat(reveal, " 750ms 0s cubic-bezier(0.21, 0.87, 0.76, 1.03)"),
      backgroundColor: colors.darkGreyOp,
      borderRadius: 3,
      color: colors.white,
      display: 'block',
      fontFamily: fonts["default"],
      marginLeft: 5,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12,
      paddingTop: 6,
      position: 'relative',
      ':before': {
        borderBottom: "5px solid ".concat(colors.transparent),
        borderRight: "5px solid ".concat(colors.darkGreyOp),
        borderTop: "5px solid ".concat(colors.transparent),
        content: '""',
        left: -5,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)'
      }
    },
    tooltipContainer: {
      left: '100%',
      overflow: 'hidden',
      paddingBottom: 3,
      paddingTop: 3,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  };
};

export default defaultStyles;
export { hide, reveal };